import pkg from '../../../package.json';

export const APP = {
  name: pkg.name,
  sdk: '@perxis-auto/instock-sdk',
} as const;
